import { storageData } from "services/Services"

const DaysDrivenList = () => {
    let options = []
    try {
        const dropdownOptions = JSON.parse(storageData.getItem('DropdownOptions'))
        const daysOptions = dropdownOptions.rows.filter(row => row.QuestionID === "153")

        if (daysOptions.length > 0) {
            options = [
                <option key="default" disabled value="">Select from the following...</option>,
                ...daysOptions.map(answer => (
                    <option key={answer.AnswerID} value={answer.AnswerText}>{answer.AnswerText}</option>
                ))
            ]
        }
    } catch (error) {
        console.error(error)
        options = [<option key="default" value="">Select from the following...</option>]
    }

    return <>{options}</>
}

export default DaysDrivenList